import * as MD from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import MuiTextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/Delete';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab/';
import * as React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N } from '../../Store/I18n/Types';
import { IUserState } from '../../Store/User/Types';
import {
	createMultipleACLUsers,
	getACLParents,
	getAllACLUsernames,
	isLoading,
	isUserAlreadyPresent,
} from '../../Store/UserManagement/Actions';
import {
	IUserManagementState,
	UserACL,
} from '../../Store/UserManagement/Types';
import { getTheme } from '../../Themes';
import { ButtonDensed } from '../../Themes/StyledElements';
import {
	isEmptyString,
	isNullOrUndefined,
	isNullOrUndefinedOrEmptyString,
	isNullOrUndefinedOrEmptyArray,
} from '../../Utils/Various';
import { countriesFiltered, languagesFiltered } from './UserManagementGlobal';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	userManagement: IUserManagementState;
}

interface IPropsFromDispatch {
	createMultipleACLUsers: typeof createMultipleACLUsers;
	getACLParents: typeof getACLParents;
	isUserAlreadyPresent: typeof isUserAlreadyPresent;
	getAllACLUsernames: typeof getAllACLUsernames;
	isLoading: typeof isLoading;
}

const dateForDateTimeInputValue = (date: Date) =>
	new Date(
		date.getTime() + new Date().getTimezoneOffset() * -60 * 1000
	).getUTCMinutes() < 10
		? new Date(date.getTime() + new Date().getTimezoneOffset() * -60 * 1000)
				.toLocaleDateString()
				.slice(0, 19) +
		  ' ' +
		  new Date(
				date.getTime() + new Date().getTimezoneOffset() * -60 * 1000
		  ).getUTCHours() +
		  ':0' +
		  new Date(
				date.getTime() + new Date().getTimezoneOffset() * -60 * 1000
		  ).getUTCMinutes() +
		  ':00'
		: new Date(date.getTime() + new Date().getTimezoneOffset() * -60 * 1000)
				.toLocaleDateString()
				.slice(0, 19) +
		  ' ' +
		  new Date(
				date.getTime() + new Date().getTimezoneOffset() * -60 * 1000
		  ).getUTCHours() +
		  ':' +
		  new Date(
				date.getTime() + new Date().getTimezoneOffset() * -60 * 1000
		  ).getUTCMinutes() +
		  ':00';

interface ICreatedUser {
	dateCreation: string;
	dateCreationFormated: string;
	dateDebut: string;
	dateDebutFormated: string;
	email: string;
	emailError: boolean;
	emailErrorMsg: string;
	firstname: string;
	isActive: boolean;
	isGroup: boolean;
	language: string;
	lastname: string;
	localisation: string[];
	parentID: number;
	parentName: string;
	parentError: boolean;
	parentErrorMsg: string;
	password: string;
	phone: string;
	position: string;
	username: string;
	usernameError: boolean;
	usernameErrorMsg: string;
}

interface IState {
	createdUsers: ICreatedUser[];
	errorCreation: boolean;
	errorCreationdMsg: string;
	hideComplementaryInformation: boolean;
	hideInformation: boolean;
	canCreateUsers: boolean;
}
type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

const theme = getTheme();

const styles = MD.createStyles({
	button: {
		margin: theme.spacing(1),
		marginLeft: 0,
		marginRight: 0,
		textTransform: 'uppercase',
	},
	card: {
		maxWidth: '55%',
		minWidth: '20%',
		margin: 'auto',
		marginTop: '3%',
	},
	cardContent: {
		width: '100%',
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
	},
	label: {
		paddingTop: '15px',
	},
	smallIcon: {
		padding: '3px',
	},
});

const DensedTextField = styled(MuiTextField)`
	.MuiInputBase-input {
		padding: 4px 6px;
		font-size: 13px;
	}
	.MuiInputLabel-formControl {
		top: -7px;
		font-size: 13px;
		font-weight: 300;
	}
`;

export class UserManagementCreationMultipleComponent extends React.Component<
	AllProps,
	IState
> {
	public constructor(props: AllProps) {
		super(props);
		this.state = this.getInitialState();
	}

	public componentDidMount() {
		this.props.getAllACLUsernames(this.props.user.token);
		this.props.getACLParents(this.props.user.token, '');
	}

	/**
	 * user doit avoir username + parent + email
	 * import et export csv
	 * validation des champs
	 * user actif
	 */

	public render(): React.ReactNode {
		return this.props.userManagement.isLoading
			? this.displayLoading()
			: this.displayCreation();
	}

	private displayCreation(): React.ReactNode {
		return (
			<React.Fragment>
				<ButtonDensed
					style={{ margin: '15px' }}
					color="secondary"
					variant="contained"
					onClick={() => {
						let update = !this.state.hideInformation;
						this.setState({ hideInformation: update });
					}}
				>
					{this.state.hideInformation
						? this.props.i18n._('Show personal information')
						: this.props.i18n._('Hide personal information')}
				</ButtonDensed>
				<ButtonDensed
					style={{ margin: '15px' }}
					color="secondary"
					variant="contained"
					onClick={() => {
						let update = !this.state.hideComplementaryInformation;
						this.setState({
							hideComplementaryInformation: update,
						});
					}}
				>
					{this.state.hideComplementaryInformation
						? this.props.i18n._('Show complementary information')
						: this.props.i18n._('Hide complementary information')}
				</ButtonDensed>
				<MD.TableContainer component={MD.Paper}>
					<MD.Table aria-label="collapsible table" size="small">
						<MD.TableHead>
							<MD.TableRow id="tablerowusercreation">
								{this.props.user.groupID === 2 ? (
									<MD.TableCell align="left">
										{this.props.i18n._('Group ?')}
									</MD.TableCell>
								) : (
									''
								)}
								<MD.TableCell align="left">
									{this.props.i18n._('Username')}
								</MD.TableCell>
								{this.state.hideInformation ? (
									<React.Fragment></React.Fragment>
								) : (
									<React.Fragment>
										<MD.TableCell align="left">
											{this.props.i18n._(
												'Last name / Group name'
											)}
										</MD.TableCell>
										<MD.TableCell align="left">
											{this.props.i18n._('First name')}
										</MD.TableCell>
										<MD.TableCell align="left">
											{this.props.i18n._('Email')}
										</MD.TableCell>
										<MD.TableCell align="left">
											{this.props.i18n._('Password')}
										</MD.TableCell>
										{this.props.user.groupID === 2 ? (
											<MD.TableCell align="left">
												{this.props.i18n._('Parent')}
											</MD.TableCell>
										) : (
											''
										)}
									</React.Fragment>
								)}
								{this.state.hideComplementaryInformation ? (
									<React.Fragment></React.Fragment>
								) : (
									<React.Fragment>
										<MD.TableCell align="left">
											{this.props.i18n._('Phone number')}
										</MD.TableCell>
										<MD.TableCell align="left">
											{this.props.i18n._('Position')}
										</MD.TableCell>
										<MD.TableCell align="left">
											{this.props.i18n._('Localisation')}
										</MD.TableCell>
										<MD.TableCell align="left">
											{this.props.i18n._('Language')}
										</MD.TableCell>
									</React.Fragment>
								)}
								<MD.TableCell align="left">
									{this.props.i18n._('Start date')}
								</MD.TableCell>
								<MD.TableCell align="left">
									{this.props.i18n._('User active')}
								</MD.TableCell>
								<MD.TableCell align="left">
									{this.props.i18n._('Remove')}
								</MD.TableCell>
							</MD.TableRow>
						</MD.TableHead>
						{this.displayTableBody()}
					</MD.Table>
				</MD.TableContainer>
				{this.generateAddRow()}
			</React.Fragment>
		);
	}

	private displayLoading(): React.ReactNode {
		return (
			<MD.Backdrop open={true}>
				<MD.CircularProgress />
			</MD.Backdrop>
		);
	}

	private displayTableBody(): React.ReactNode {
		return (
			<MD.TableBody>
				{this.state.createdUsers.map((u, i) => this.generateRow(u, i))}
			</MD.TableBody>
		);
	}

	private generateAddRow() {
		return (
			<React.Fragment>
				<ButtonDensed
					style={{ marginTop: '15px', marginLeft: '15px' }}
					color="primary"
					variant="contained"
					onClick={() => this.addCreatedUser(false)}
				>
					{this.props.i18n._('Add user')}
				</ButtonDensed>
				{this.props.user.groupID === 2 ? (
					<ButtonDensed
						style={{ marginTop: '15px', marginLeft: '15px' }}
						color="primary"
						variant="contained"
						onClick={() => this.addCreatedUser(true)}
					>
						{this.props.i18n._('Add group')}
					</ButtonDensed>
				) : (
					''
				)}
				<ButtonDensed
					disabled={!this.state.canCreateUsers}
					style={{ marginTop: '15px', marginLeft: '15px' }}
					color="secondary"
					variant="contained"
					onClick={() => this.onSubmit()}
				>
					{this.props.i18n._('Submit')}
				</ButtonDensed>
			</React.Fragment>
		);
	}

	private conditionForSubmit() {
		let condition = false;

		if (this.state.createdUsers.length <= 0) {
			this.setState({ canCreateUsers: condition });
			return;
		}

		let allerror: boolean[] = [];

		this.state.createdUsers.forEach((element) => {
			if (!element.isGroup) {
				allerror.push(element.emailError);
				allerror.push(element.parentError);
			}
			allerror.push(element.usernameError);
		});

		if (allerror.includes(true)) {
			this.setState({ canCreateUsers: condition });
			return;
		}

		condition = true;
		this.setState({ canCreateUsers: condition });
	}

	private hasDuplicates<T>(arr: T[]): boolean {
		return new Set(arr).size < arr.length;
	}

	private addCreatedUser(group: boolean) {
		const createdUsers = this.state.createdUsers;
		const newUser = this.getEmptyUser();

		if (group) {
			newUser.isGroup = true;
		}
		createdUsers.push(newUser);
		this.setState({ createdUsers });
		this.conditionForSubmit();
	}

	private generateRow(user: ICreatedUser, i: number) {
		return (
			<MD.TableRow key={`createdUser_${i}`}>
				{this.props.user.groupID === 2 ? (
					<MD.TableCell>
						<MD.Switch
							checked={user.isGroup}
							onChange={(
								event: React.ChangeEvent,
								checked: boolean
							) => {
								this.updateInformation(i, 'isgroup', checked);
							}}
						/>
					</MD.TableCell>
				) : (
					''
				)}
				{user.isGroup
					? this.generateCellsGroup(user, i)
					: this.generateCellsUser(user, i)}
			</MD.TableRow>
		);
	}

	private generateCellsGroup(user: ICreatedUser, i: number) {
		const classes = this.props.classes;
		return (
			<React.Fragment key={`user_cells_${i}`}>
				<MD.TableCell>
					<DensedTextField
						error={user.usernameError}
						helperText={user.usernameErrorMsg}
						margin="normal"
						value={user.username}
						onChange={(
							event: React.ChangeEvent<HTMLInputElement>
						) => {
							this.updateInformation(
								i,
								'username',
								event.target.value
							);
						}}
					/>
				</MD.TableCell>

				{this.state.hideInformation ? (
					<React.Fragment></React.Fragment>
				) : (
					<MD.TableCell>
						<DensedTextField
							margin="normal"
							value={user.lastname}
							onChange={(
								event: React.ChangeEvent<HTMLInputElement>
							) => {
								this.updateInformation(
									i,
									'lastname',
									event.target.value
								);
							}}
						/>
					</MD.TableCell>
				)}

				{this.state.hideComplementaryInformation ? (
					this.state.hideInformation ? (
						<React.Fragment></React.Fragment>
					) : (
						<MD.TableCell
							colSpan={
								4 // true & false
							}
						></MD.TableCell>
					)
				) : this.state.hideInformation ? (
					<MD.TableCell
						colSpan={
							4 // false & true
						}
					></MD.TableCell>
				) : (
					<MD.TableCell
						colSpan={
							8 // false & false
						}
					></MD.TableCell>
				)}
				<MD.TableCell>
					<DensedTextField
						margin="normal"
						value={user.dateDebut}
						onChange={(
							event: React.ChangeEvent<HTMLInputElement>
						) => {
							this.updateInformation(
								i,
								'datedebut',
								event.target.value
							);
						}}
					/>
				</MD.TableCell>
				<MD.TableCell>
					<MD.Switch
						checked={user.isActive}
						onChange={(
							event: React.ChangeEvent,
							checked: boolean
						) => {
							this.updateInformation(i, 'isactive', checked);
						}}
					/>
				</MD.TableCell>

				<MD.TableCell>
					<IconButton
						className={classes.smallIcon}
						color="primary"
						aria-label="delete row"
						component="span"
						onClick={(
							event: React.MouseEvent<
								HTMLButtonElement,
								MouseEvent
							>
						) => {
							this.onDeletion(i);
						}}
					>
						<DeleteIcon style={{ color: red[500] }} />
					</IconButton>
				</MD.TableCell>
			</React.Fragment>
		);
	}

	private generateCellsUser(user: ICreatedUser, i: number) {
		const classes = this.props.classes;
		return (
			<React.Fragment key={`user_cells_${i}`}>
				<MD.TableCell>
					<DensedTextField
						error={user.usernameError}
						helperText={user.usernameErrorMsg}
						margin="normal"
						value={user.username}
						onChange={(
							event: React.ChangeEvent<HTMLInputElement>
						) => {
							this.updateInformation(
								i,
								'username',
								event.target.value
							);
							if (this.props.user.groupID !== 2) {
								this.updateInformation(
									i,
									'parentid',
									this.props.user.groupID
								);
							}
						}}
					/>
				</MD.TableCell>

				{this.state.hideInformation ? (
					<React.Fragment></React.Fragment>
				) : (
					<React.Fragment>
						<MD.TableCell>
							<DensedTextField
								margin="normal"
								value={user.lastname}
								onChange={(
									event: React.ChangeEvent<HTMLInputElement>
								) => {
									this.updateInformation(
										i,
										'lastname',
										event.target.value
									);
								}}
							/>
						</MD.TableCell>
						<MD.TableCell>
							<DensedTextField
								margin="normal"
								value={user.firstname}
								onChange={(
									event: React.ChangeEvent<HTMLInputElement>
								) => {
									this.updateInformation(
										i,
										'firstname',
										event.target.value
									);
								}}
							/>
						</MD.TableCell>
						<MD.TableCell>
							<DensedTextField
								error={user.emailError}
								helperText={user.emailErrorMsg}
								margin="normal"
								type="email"
								value={user.email}
								onChange={(
									event: React.ChangeEvent<HTMLInputElement>
								) => {
									this.updateInformation(
										i,
										'email',
										event.target.value
									);
								}}
							/>
						</MD.TableCell>
						<MD.TableCell>
							<DensedTextField
								margin="normal"
								type="password"
								value={user.password}
								onChange={(
									event: React.ChangeEvent<HTMLInputElement>
								) => {
									this.updateInformation(
										i,
										'password',
										event.target.value
									);
								}}
							/>
						</MD.TableCell>
						{this.props.user.groupID === 2 ? (
							<MD.TableCell>
								<Autocomplete
									id="combo-box-parent"
									options={this.getPossibleParents()}
									onChange={(
										ev: React.ChangeEvent<{}>,
										val: any
									) => {
										if (
											!isNullOrUndefined(val) &&
											!isNullOrUndefinedOrEmptyString(
												val.username
											)
										) {
											this.updateInformation(
												i,
												'parentid',
												val.id
											);
											this.updateInformation(
												i,
												'parentname',
												val.username
											);
										}
									}}
									getOptionLabel={(option) => option.username}
									renderInput={(
										params: AutocompleteRenderInputParams
									) => (
										<MD.TextField
											{...params}
											error={user.parentError}
											helperText={user.parentErrorMsg}
											label={this.props.i18n._('Parent')}
											value={user.parentName}
											onChange={(event: any) => {
												this.props.getACLParents(
													this.props.user.token,
													event.target.value
												);
											}}
										/>
									)}
								/>
							</MD.TableCell>
						) : (
							''
						)}
					</React.Fragment>
				)}
				{this.state.hideComplementaryInformation ? (
					<React.Fragment></React.Fragment>
				) : (
					<React.Fragment>
						<MD.TableCell>
							<PhoneInput
								specialLabel=""
								containerStyle={{
									color: '#C4C4C4',
									padding: '5px 5px',
									fontSize: '13px',
								}}
								inputStyle={{
									color: '#C4C4C4',
									width: '100%',
									padding: '5px 5px 5px 58px',
									backgroundColor: 'transparent',
								}}
								buttonStyle={{}}
								dropdownStyle={{
									backgroundColor: '#35394B',
									width: 'max-content',
								}}
								searchStyle={{ backgroundColor: '#C54CFB' }}
								country={'fr'}
								regions={'europe'}
								value={user.phone}
								onChange={(value: string) => {
									this.updateInformation(i, 'phone', value);
								}}
							/>
						</MD.TableCell>
						<MD.TableCell>
							<DensedTextField
								margin="normal"
								value={user.position}
								onChange={(
									event: React.ChangeEvent<HTMLInputElement>
								) => {
									this.updateInformation(
										i,
										'position',
										event.target.value
									);
								}}
							/>
						</MD.TableCell>
						<MD.TableCell>
							<MD.Select
								multiple
								value={user.localisation}
								onChange={(
									event: React.ChangeEvent<{ value: unknown }>
								) => {
									this.updateInformation(
										i,
										'localisation',
										event.target.value as string[]
									);
								}}
								input={<MD.Input />}
								renderValue={(selected) =>
									(selected as string[]).join(', ')
								}
							>
								{countriesFiltered.map((country) => (
									<MD.MenuItem
										key={country.code}
										value={country.code}
									>
										<MD.Checkbox
											checked={
												user.localisation.indexOf(
													country.code
												) > -1
											}
										/>
										<MD.ListItemText
											primary={country.label}
										/>
									</MD.MenuItem>
								))}
							</MD.Select>
						</MD.TableCell>
						<MD.TableCell>
							<MD.Select
								value={user.language}
								onChange={(
									event: React.ChangeEvent<{ value: unknown }>
								) => {
									this.updateInformation(
										i,
										'language',
										event.target.value as string
									);
								}}
								input={<MD.Input />}
								renderValue={(selected) => selected as string}
							>
								{languagesFiltered.map((language) => (
									<MD.MenuItem
										key={language.code}
										value={language.label}
									>
										<MD.ListItemText
											primary={language.label}
										/>
									</MD.MenuItem>
								))}
							</MD.Select>
						</MD.TableCell>
					</React.Fragment>
				)}
				<MD.TableCell>
					<DensedTextField
						margin="normal"
						value={user.dateDebut}
						onChange={(
							event: React.ChangeEvent<HTMLInputElement>
						) => {
							this.updateInformation(
								i,
								'datedebut',
								event.target.value
							);
						}}
					/>
				</MD.TableCell>
				<MD.TableCell>
					<MD.Switch
						checked={user.isActive}
						onChange={(
							event: React.ChangeEvent,
							checked: boolean
						) => {
							this.updateInformation(i, 'isactive', checked);
						}}
					/>
				</MD.TableCell>
				<MD.TableCell>
					<IconButton
						className={classes.smallIcon}
						color="primary"
						aria-label="delete row"
						component="span"
						onClick={(
							event: React.MouseEvent<
								HTMLButtonElement,
								MouseEvent
							>
						) => {
							this.onDeletion(i);
						}}
					>
						<DeleteIcon style={{ color: red[500] }} />
					</IconButton>
				</MD.TableCell>
			</React.Fragment>
		);
	}

	private updateInformation(
		index: number,
		parameter: string,
		value: boolean | string | number | string[]
	) {
		const createdUsers = this.state.createdUsers;

		const err = false;
		const errMsg = '';

		let allusername: string[] = [];

		this.state.createdUsers.forEach((element, i) => {
			if (index !== i) {
				allusername.push(element.username);
			}
		});
		switch (parameter) {
			case 'isgroup':
				if (typeof value == 'boolean') {
					createdUsers[index].isGroup = value;
				}
				break;
			case 'username':
				if (typeof value == 'string') {
					createdUsers[index].username = value.toLowerCase();
					createdUsers[index].usernameError = err;
					createdUsers[index].usernameErrorMsg = errMsg;

					if (isEmptyString(value)) {
						createdUsers[index].usernameError = true;
						createdUsers[index].usernameErrorMsg =
							'username must be completed';

						break;
					}
					if (value !== undefined) {
						if (
							this.props.userManagement.allUsernames.includes(
								value.toLowerCase()
							) ||
							this.props.userManagement.allEmail.includes(
								value.toLowerCase()
							) ||
							allusername.includes(value.toLowerCase())
						) {
							createdUsers[index].usernameError = true;
							createdUsers[index].usernameErrorMsg =
								'username already used';
							break;
						}
					}
				}
				break;
			case 'lastname':
				if (typeof value == 'string') {
					createdUsers[index].lastname = value;
				}
				break;
			case 'firstname':
				if (typeof value == 'string') {
					createdUsers[index].firstname = value;
				}
				break;
			case 'email':
				if (typeof value == 'string') {
					createdUsers[index].email = value.toLowerCase();
					createdUsers[index].emailError = err;
					createdUsers[index].emailErrorMsg = errMsg;
					if (isEmptyString(value)) {
						createdUsers[index].emailError = true;
						createdUsers[index].emailErrorMsg =
							'email must be completed';
					}

					const re =
						/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

					if (!re.test(value)) {
						createdUsers[index].emailError = true;
						createdUsers[index].emailErrorMsg =
							'email must be valid';
					}
				}
				break;
			case 'password':
				if (typeof value == 'string') {
					createdUsers[index].password = value;
				}
				break;
			case 'parentid':
				if (typeof value == 'number') {
					createdUsers[index].parentID = value;
				}
				break;
			case 'parentname':
				if (typeof value == 'string') {
					createdUsers[index].parentName = value;
					createdUsers[index].parentError = err;
					createdUsers[index].parentErrorMsg = errMsg;
					if (isEmptyString(value)) {
						createdUsers[index].parentError = true;
						createdUsers[index].parentErrorMsg =
							'parent must be selected';
					}
				}
				break;
			case 'phone':
				if (typeof value == 'string') {
					createdUsers[index].phone = value;
				}
				break;
			case 'position':
				if (typeof value == 'string') {
					createdUsers[index].position = value;
				}
				break;
			case 'localisation':
				if (typeof value == 'object') {
					if (isNullOrUndefinedOrEmptyArray(value)) {
						value = ['FR'];
					}
					createdUsers[index].localisation = value;
				}
				break;
			case 'language':
				if (typeof value == 'string') {
					if (isNullOrUndefinedOrEmptyString(value)) {
						value = 'French';
					}
					createdUsers[index].language = value;
				}
				break;
			case 'datedebut':
				if (typeof value == 'string') {
					createdUsers[index].dateDebut = value;
				}
				break;
			case 'isactive':
				if (typeof value == 'boolean') {
					createdUsers[index].isActive = value;
				}
				break;
		}
		this.setState({ createdUsers });
		this.conditionForSubmit();
	}

	private onDeletion(i: number) {
		let createdUsers = this.state.createdUsers;

		let forDeletion = [createdUsers[i]];

		createdUsers = createdUsers.filter(
			(item) => !forDeletion.includes(item)
		);

		this.setState({ createdUsers });
		this.conditionForSubmit();
	}

	private onSubmit() {
		this.props.createMultipleACLUsers(
			this.props.user.token,
			this.state.createdUsers
		);
		this.setState(this.getInitialState());
	}
	private getInitialState(): IState {
		return {
			errorCreation: false,
			errorCreationdMsg: '',
			createdUsers: [],
			hideComplementaryInformation: true,
			hideInformation: false,
			canCreateUsers: false,
		};
	}

	private getEmptyUser(): ICreatedUser {
		return {
			dateCreation: dateForDateTimeInputValue(new Date()),
			dateCreationFormated: '',
			dateDebut: dateForDateTimeInputValue(new Date()),
			dateDebutFormated: '',
			email: '',
			emailError: true,
			emailErrorMsg: 'email must be completed',
			firstname: '',
			isActive: true,
			isGroup: false,
			language: 'French',
			lastname: '',
			localisation: ['FR'],
			parentID: 0,
			parentName: '',
			parentError: true,
			parentErrorMsg: '',
			password: '',
			phone: '',
			position: '',
			username: '',
			usernameError: true,
			usernameErrorMsg: 'username must be completed',
		};
	}

	private getPossibleParents(): UserACL[] {
		const parents = [...this.props.userManagement.parentsACLData];

		this.state.createdUsers.forEach((u: ICreatedUser) => {
			if (u.isGroup) {
				parents.push({
					id: 0,
					username: u.username,
				} as UserACL);
			}
		});
		return parents;
	}
}
const mapStateToProps = (
	{ i18n, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	createMultipleACLUsers: (token: string, params: ICreatedUser[]) =>
		dispatch(createMultipleACLUsers(token, params)),
	getACLParents: (token: string, researchField: string) =>
		dispatch(getACLParents(token, researchField)),
	isUserAlreadyPresent: (token: string, username: string) =>
		dispatch(isUserAlreadyPresent(token, username)),
	isLoading: (loading: boolean) => dispatch(isLoading(loading)),
	getAllACLUsernames: (token: string) => dispatch(getAllACLUsernames(token)),
});

export const UserManagementCreationMultiple = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(UserManagementCreationMultipleComponent));
